import { StoreState } from '../store'

export const selectUserInfo = (state: StoreState) => state.userInfo
